/**
 * ⚖️ RPL-1 … RPL-5 — THE STRINGS OF RECORD for the season-plan surface's
 * refusal line (R71) and proposal frame (R72).
 *
 * CD 2026-08-22 · `cd-2026-08-22-race-scale-pointers/CD-RULINGS-…md` §2 carries
 * the characters of record. 👤 RATIFIED 2026-08-22 by the founder (condition
 * C40) with the ⚕ minors read PASSING on RPL-1 / 3 / 5 the same day —
 * `COPY-LEDGER.md` row `RPL ✅` is the sign-off of record, and
 * `seasonPlanCopy.test.ts` pins every character against it.
 *
 * ⛔ COPIED, NEVER RETYPED. No string below may be edited outside a CD session
 * plus founder sign-off. All five are dash-free per the founder's rule for
 * newly authored strings, and clean against the standing banned set: no
 * exclamation, no `safe`, no performance verdict, no pressuring line, no health
 * category, no all-clear the data cannot support.
 *
 * The register these five hold, and why each is worded as it is:
 *   · RPL-1 carries the only two facts a reader needs when a generate is
 *     refused — something is already in progress, and HER WEEK HAS NOT
 *     CHANGED. Nothing about it is an incident, and a minor reads it as one if
 *     the chrome says so.
 *   · RPL-3 is permanently visible inside the proposal frame, never folded and
 *     never scrolled away: a fold hides elaboration, never existence.
 *   · RPL-5 says WHO decides, which is why the athlete needs no control of her
 *     own — offering one she cannot use is how a preview turns into a promise.
 */

/** RPL-1 · athlete plan surface · generate refused (409). */
export const RPL_REFUSED =
  'A new plan is already being put together. Your week stays as it is for now.';

/**
 * ⚠️ NOT one of the five CD strings above, and not covered by their sign-off:
 * the roll-forward refusal (round-22 UX D2, 2026-09-09), which lives here for
 * the reason RPL-1 does — one producer, imported by everyone who renders or
 * recognises it.
 *
 * B13's `expectNew` abort is not a failure: the season simply has not expired
 * yet, and nothing the athlete does today changes that. `useStartSeason`
 * raises it; `SeasonRecapCard` recognises it and renders a quiet line with the
 * CTA at rest instead of red incident chrome under a "Try again" that cannot
 * work.
 *
 * ⚖️ It sits in this module, not in the hook that raises it (round-29 critic
 * 7). A component that imports a CONSTANT from a hooks module is broken by any
 * test that mocks that module without spreading `...actual` — five test files
 * mock `hooks/useStartSeason` and only one spreads it, so the card was one
 * unrelated test edit away from throwing on a constant that exists. A copy
 * module has nothing to mock.
 *
 * Register (founder ruling 2026-09-09 23:01 PT): no dash, no exclamation.
 */
export const SEASON_NOT_ROLLED_OVER_MESSAGE =
  "Your season hasn't rolled over yet. Try again tomorrow.";

/** RPL-2 · proposal frame kicker. Uppercased by CSS ONLY — never in the data. */
export const RPL_PROPOSAL_KICKER = 'Proposed plan';

/** RPL-3 · proposal frame header · ALWAYS VISIBLE. */
export const RPL_PROPOSAL_CLARITY =
  'This is a proposal from your coach. Your plan has not changed.';

/** RPL-4 · coach / founder surface · the accept control. NEVER athlete-side. */
export const RPL_ACCEPT = 'Replace the week with this plan';

/** RPL-5 · proposal frame footer · athlete side. */
export const RPL_PROPOSAL_FOOTER = 'Your coach will tell you if this becomes your plan.';

/**
 * The server's B13 in-flight guard code. A `409` carrying THIS code is the one
 * refusal R71 renders; every other failure keeps the surface it already had.
 */
export const REPLAN_BLOCKED_CODE = 'replan_blocked_in_flight';

/** Is this error the B13 refusal? (mirrors `isRoleRefusal`'s shape). */
export function isReplanBlocked(err: unknown): boolean {
  return (
    !!err &&
    typeof err === 'object' &&
    (err as { code?: unknown }).code === REPLAN_BLOCKED_CODE
  );
}
